import type { FeatureFlagValue } from '~/utils/featureFlags';

import UserEvent from './UserEvent';

type EventData = {
  flag: string;
  isBot: boolean;
  url: string;
  variant: FeatureFlagValue;
};

class ExperimentExposureEvent extends UserEvent<EventData> {
  collectServerEvents() {
    this.serverEvents.push({
      data: {
        flag: this.data.flag,
        url: this.data.url,
        variant: this.data.variant
      },
      type: 'experiment_exposure'
    });
  }
}

export default ExperimentExposureEvent;
